import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { map } from 'rxjs';
import { UserVisualConfiguration } from '@app/shared/interfaces/configuracion-visual/config-visual';


@Injectable({
  providedIn: 'root'
})
export class ConfiguracionVisualService {


  constructor(private http: HttpClient, private cs: ConfigService) {
  }

  getConfiguracionVisual() {
    return this.http
      .get<any>(`${this.cs.urlEnviroment}api/ConfiguracionVisual`)
      .pipe(
        map(response => {
          if (response.ok && response.data) {
            const data = response.data;
            const config: UserVisualConfiguration = data;
            return config;
          }
          return null
        })
      );
  }

  CrearActualizarConfiguracionVisual(data: UserVisualConfiguration) {
    return this.http.post(`${this.cs.urlEnviroment}api/ConfiguracionVisual`, data)
  }

}
